export default function Proposals() {
  return (
    <section
      id="proposals"
      className="relative w-full py-20 flex flex-col items-center"
      style={{ backgroundImage: `url('./membershipBg.png')`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}
    >
      <div className="max-w-6xl w-full mx-auto px-4 flex flex-col items-center">
        <h2 className="text-5xl font-medium text-white text-center mb-8">Proposals</h2>
        <p className="text-lg text-white text-center mb-16 max-w-3xl mx-auto">
          Proposals are the lifeblood of XAO DAO, giving members <span className="font-bold italic">a direct way</span> to influence and build the ecosystem.<br/><br/>
          Members may propose:
        </p>
        <div className="flex flex-col md:flex-row gap-6 justify-center mb-12 mt-10 items-center">
          <div className="relative">
            <img src="/proposal1.png" alt="Proposal 1" className="w-80 h-48 object-fit rounded-xl shadow max-w-full" />
            <img
              src="/Number1.png"
              alt="Number 1"
              className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12"
            />
          </div>
          <div className="relative">
            <img src="/proposal2.png" alt="Proposal 2" className="w-80 h-48 object-fit rounded-xl shadow max-w-full" />
            <img
              src="/Number2.png"
              alt="Number 2"
              className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12"
            />
          </div>
          <div className="relative">
            <img src="/proposal3.png" alt="Proposal 3" className="w-80 h-48 object-fit rounded-xl shadow max-w-full" />
            <img
              src="/Number3.png"
              alt="Number 3"
              className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-6 justify-center mb-12 items-center">
          <div className="relative">
            <img src="/proposal4.png" alt="Proposal 4" className="w-80 h-48 object-fit rounded-xl shadow max-w-full" />
            <img
              src="/Number4.png"
              alt="Number 4"
              className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12"
            />
          </div>
          <div className="relative">
            <img src="/proposal5.png" alt="Proposal 5" className="w-80 h-48 object-fit rounded-xl shadow max-w-full" />
            <img
              src="/Number5.png"
              alt="Number 5"
              className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12"
            />
          </div>
        </div>
        <p className="text-base pt-20 mb-10 text-white text-center max-w-3xl mx-auto">
          Each proposal goes through a transparent review and voting process. Only proposals that achieve the required community support are approved and implemented. This ensures that all major actions are taken with the consent of the community, not by a small group of individuals.
        </p>
      </div>
    </section>
  );
}